/**
 * Case Studies
 * Make entire card clickable
 *
 * @since   1.0.0
 * @package veristream
 */
(function($) {
	$('#caseStudies').find('.elementor-widget-call-to-action').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		window.open(
			$(this).find('.elementor-cta__button').attr('href'),
		  '_blank' // <- This is what makes it open in a new window.
		);

	}).addClass('-clickable');
})(jQuery);
